export const DOWNLOAD_ARN_LOADING = 'DOWNLOAD_ARN_LOADING'
export const DOWNLOAD_ARN_SUCCESS = 'DOWNLOAD_ARN_SUCCESS'
export const DOWNLOAD_ARN_FAILED = 'DOWNLOAD_ARN_FAILED'